import { render, staticRenderFns } from "./Cameras.vue?vue&type=template&id=2136a30c&scoped=true"
import script from "./Cameras.vue?vue&type=script&lang=js"
export * from "./Cameras.vue?vue&type=script&lang=js"
import style0 from "./Cameras.vue?vue&type=style&index=0&id=2136a30c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2136a30c",
  null
  
)

export default component.exports